import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "card mt-2" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = {
  key: 0,
  class: "fa fa-lock text-danger",
  title: "Survey is closed"
}
const _hoisted_9 = {
  key: 1,
  class: "fa fa-unlock-alt text-success",
  title: "Survey is open"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col text-nowrap" }
const _hoisted_12 = { class: "text-primary" }
const _hoisted_13 = { class: "col text-nowrap" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col text-nowrap" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "col text-nowrap" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col text-nowrap" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "btn btn-sm btn-outline-secondary"
}
const _hoisted_23 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm btn-outline-secondary"
}
const _hoisted_24 = { class: "dropdown d-inline-block" }
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoringSurveyAccessLinks = _resolveComponent("ScoringSurveyAccessLinks")!
  const _component_ScoringSurveyEmailSender = _resolveComponent("ScoringSurveyEmailSender")!
  const _component_SurveyOpenerDialog = _resolveComponent("SurveyOpenerDialog")!
  const _component_SurveyCloserDialog = _resolveComponent("SurveyCloserDialog")!
  const _component_SurveyAlternativesManagerDialog = _resolveComponent("SurveyAlternativesManagerDialog")!
  const _component_SurveyCriteriaManagerDialog = _resolveComponent("SurveyCriteriaManagerDialog")!
  const _component_SubSurveysManagerDialog = _resolveComponent("SubSurveysManagerDialog")!
  const _component_SurveyEditorDialog = _resolveComponent("SurveyEditorDialog")!
  const _component_ScoresExporter = _resolveComponent("ScoresExporter")!
  const _component_AttributeEditorDialog = _resolveComponent("AttributeEditorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ScoringSurveyAccessLinks, {
      viewModel: _ctx.scoringSurveyAccessLinks,
      onShowEmailSender: _ctx.handleShowEmailSender,
      onDownloadLinks: _ctx.handleDownloadAccessLinks
    }, null, 8 /* PROPS */, ["viewModel", "onShowEmailSender", "onDownloadLinks"]),
    _createVNode(_component_ScoringSurveyEmailSender, {
      viewModel: _ctx.scoringSurveyEmailSender,
      onSendEmail: _ctx.handleSendEmailCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail"]),
    _createVNode(_component_SurveyOpenerDialog, {
      propOpened: _ctx.surveyOpenerSurveyId != null,
      propSurveyId: _ctx.surveyOpenerSurveyId,
      onStartSurvey: _ctx.handleStartSurveyCommand,
      onShowAccessLinks: _ctx.showAccessLinks,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.surveyOpenerSurveyId = null))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyId", "onStartSurvey", "onShowAccessLinks"]),
    _createVNode(_component_SurveyCloserDialog, {
      propOpened: _ctx.surveyCloserSurveyId != null,
      propSurveyId: _ctx.surveyCloserSurveyId,
      onStopSurvey: _ctx.handleStopSurveyCommand,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.surveyCloserSurveyId = null))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyId", "onStopSurvey"]),
    _createVNode(_component_SurveyAlternativesManagerDialog, {
      viewModel: _ctx.surveyAlternativesManagerDialog,
      onPreviewDescription: _ctx.handleLoadAlternativeDescription,
      onLoadAlternatives: _ctx.handleLoadAlternativesByList,
      onSaveSurvey: _ctx.handleUpdateSurveyAlternativesCommand
    }, null, 8 /* PROPS */, ["viewModel", "onPreviewDescription", "onLoadAlternatives", "onSaveSurvey"]),
    _createVNode(_component_SurveyCriteriaManagerDialog, {
      viewModel: _ctx.surveyCriteriaManagerDialog,
      onUpdateSurveyCriteria: _ctx.handleUpdateSurveyCriteriaCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateSurveyCriteria"]),
    _createVNode(_component_SubSurveysManagerDialog, {
      viewModel: _ctx.subSurveysManagerDialog,
      onIncludeSubSurvey: _ctx.handleIncludeSubSurveyCommand,
      onExcludeSubSurvey: _ctx.handleExcludeSubSurveyCommand,
      onChangeVoteStrength: _ctx.handleChangeSubSurveyVoteStrengthCommand
    }, null, 8 /* PROPS */, ["viewModel", "onIncludeSubSurvey", "onExcludeSubSurvey", "onChangeVoteStrength"]),
    _createVNode(_component_SurveyEditorDialog, {
      viewModel: _ctx.surveyEditorDialog,
      onDeleteSurvey: _ctx.handleDeleteSurveyCommand,
      onCreateSurvey: _ctx.handleCreateSurveyCommand,
      onUpdateSurvey: _ctx.handleUpdateSurveyCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteSurvey", "onCreateSurvey", "onUpdateSurvey"]),
    _createVNode(_component_ScoresExporter, {
      viewModel: _ctx.scoresExporter,
      onShowAttributeCreator: _ctx.showAttributeCreator,
      onLoadPreview: _ctx.loadScoresExporterPreview,
      onResetPreview: _ctx.resetScoresExporterPreview,
      onExportScores: _ctx.handleExportSurveyScoresToAttributesCommand,
      onCloseDialog: _ctx.closeScoresExporter
    }, null, 8 /* PROPS */, ["viewModel", "onShowAttributeCreator", "onLoadPreview", "onResetPreview", "onExportScores", "onCloseDialog"]),
    _createVNode(_component_AttributeEditorDialog, {
      viewModel: _ctx.attributeEditorDialog,
      onNumericAttributeCreated: _ctx.numericAttributeCreated
    }, null, 8 /* PROPS */, ["viewModel", "onNumericAttributeCreated"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.rm)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[11] || (_cache[11] = _createElementVNode("a", {
              class: "btn btn-outline-secondary float-right",
              href: "https://www.transparentchoice.com/user-guide/pick-a-winner",
              title: "User guide: Pick a winner",
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info",
                "aria-hidden": "true"
              })
            ], -1 /* CACHED */)),
            _createElementVNode("h3", null, "Goal: " + _toDisplayString(_ctx.rm.GoalName), 1 /* TEXT */),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ActivePage: "scoring-surveys",
              ScoringEnabled: true
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId"]),
            _createElementVNode("button", {
              role: "button",
              class: "btn btn-success",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSurveyCreator && _ctx.showSurveyCreator(...args)))
            }, " Create opinion panel "),
            _createElementVNode("button", {
              role: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleExportAllScoringVotesToXlsCommand && _ctx.handleExportAllScoringVotesToXlsCommand(...args)))
            }, " Export votes "),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveysView, (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                  key: s.Id
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h5", _hoisted_7, [
                        (s.SurveyStarted === false)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                          : _createCommentVNode("v-if", true),
                        (s.SurveyStarted === true)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", null, _toDisplayString(s.Name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [
                            _createTextVNode("Panelists: " + _toDisplayString(s.RespondentsCount), 1 /* TEXT */)
                          ])), [
                            [_directive_sanitizedHref, _ctx.url_ScoringPanelistsPage(s.Id)]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("a", {
                            class: "text-primary",
                            onClick: ($event: any) => (_ctx.showSubSurveysManager(s.Id))
                          }, "Combined panels: " + _toDisplayString(s.SubSurveysCount), 9 /* TEXT, PROPS */, _hoisted_14)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("a", {
                            class: "text-primary",
                            onClick: ($event: any) => (_ctx.showSurveyCriteriaManager(s.Id))
                          }, "Criteria: " + _toDisplayString(s.CriteriaCount) + "/" + _toDisplayString(_ctx.rm.CriteriaCount), 9 /* TEXT, PROPS */, _hoisted_17)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", null, "Questions: " + _toDisplayString(s.QuestionsCount), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("a", {
                            class: "text-primary",
                            onClick: ($event: any) => (_ctx.showSurveyAlternativesManager(s.Id))
                          }, _toDisplayString(_ctx.rm.AlternativesLabel) + ": " + _toDisplayString(s.AlternativesCount) + "/" + _toDisplayString(_ctx.rm.AlternativesCount), 9 /* TEXT, PROPS */, _hoisted_21)
                        ])
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      (s.HasQuestions === true)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_22, [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Review", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, _ctx.url_ScoringMeetingManagerPage(s.Id)]
                          ])
                        : _createCommentVNode("v-if", true),
                      (s.HasQuestions === false)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_23, "Review"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[9] || (_cache[9] = _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                          type: "button",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showSurveyEditor(s))
                          }, "Edit", 8 /* PROPS */, _hoisted_26),
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          (s.SurveyStarted === false)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showSurveyOpener(s.Id))
                              }, "Open survey", 8 /* PROPS */, _hoisted_27))
                            : _createCommentVNode("v-if", true),
                          (s.SurveyStarted === true)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showSurveyCloser(s.Id))
                              }, "Close survey", 8 /* PROPS */, _hoisted_28))
                            : _createCommentVNode("v-if", true),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showScoresExporter(s.Id))
                          }, "Save scores", 8 /* PROPS */, _hoisted_29),
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.confirmSurveyDelete(s))
                          }, "Delete", 8 /* PROPS */, _hoisted_30)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}